import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
    Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { deleteAndRestoreProduct } from "../reduxSaga/actions";
import { Alert, Snackbar } from "@mui/material";
import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import UtilsFormule from "../utils/UtilsFormule";
import UtilsUrl from "../utils/UtilsUrl";
import FileService from "../services/FileService";
import getCurrentUserId from "../reduxSaga/sagas/requests/currentUserId";
import uploadAndDownloadService from "../services/uploadAndDownloadFile";



const DataTableBonDeSortieSell = ({ document, listTransactions }) => {
    // console.log("listTransactions", listTransactions);
    const [documentName, setDocumentName] = useState(document);
    const [pathFile, setPathFile] = useState(document);

    const [transaction, setTransaction] = useState(listTransactions);
    // const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [infoAlertText, setInfoAlertText] = useState();
    const [openInfoAlert, setOpenInfoAlert] = useState(false);

    const { SearchBar } = Search;
    const MyExportCSV = (props) => {
        const handleClick = () => {
            props.onExport();
        };
        return (
            <div>
                <button className="btn btn-dark" onClick={handleClick}>
                    <i class="fas fa-download"></i> Télécharger CSV
                </button>
            </div>
        );
    };


    function dateFormatter(cell, row) {
        return <span>{UtilsFormule.formatDateHours(cell)}</span>;
    }
    function refFormatterDocument(document) {
        if (document.facture) {
            return <span>{document.facture.ref}</span>;
        } else if (document.bdc) {
            return <span>{document.bdc?.ref}</span>;

        } else if (document.bonDeCommandeSale ) {
            return <span>{document.bonDeCommandeSale?.ref}</span>;

        }else if (document.productionOrder) {
            return <span>{document.productionOrder?.code}</span>;

        }
    }

    function testProduction(document) {
       if (document.productionOrder) {
            return <span className="badge bg-primary float-right">Ordre de production</span>;

        }
    }
    function titleFormatterDoument(document) {
        // console.log("titleFormatterDoument",document.bonDeCommandeSale.title)
        if (document.facture) {
            return <span>{document.facture?.title}</span>;
        } else if (document.bdc) {
            return <span>{document.bdc?.title}</span>;
        }  else if (document.bonDeCommandeSale) {
            console.log("titleFormatterDoument",document.bonDeCommandeSale.title)
            return <span>{document.bonDeCommandeSale?.title}</span>;
        }else if (document.productionOrder) {
            return <span>{document.productionOrder?.name}</span>;

        }
    }


    const columns = [
        {
            dataField: "uniqueId",
            text: "Réf",
            headerAlign: "center",
            headerStyle: () => {
                return { width: "15%" };
            },
        },
        {
            dataField: "creationDate",
            text: "Date livraison",
            align: "center",
            formatter: dateFormatter,
            headerAlign: "center",
            headerStyle: () => {
                return { width: "15%" };
            },
        },

        {
            dataField: "path",
            text: "document",
            headerAlign: "center",
            align: "center",

            formatter: buttonFormatter,

            headerStyle: () => {
                return { width: "10%" };
            },
        },
    ];
    const onShowFileInOtherWindowHandler = (path) => {
        uploadAndDownloadService
            .downloadFile(path)
            .then((response) => {
                //Build a URL from the file
                if (response.headers["content-type"] === "image/png") {
                    const file = new Blob([response.data], { type: "image/png" });
                    const fileURL = URL.createObjectURL(file);
                    //Open the URL on new Window
                    const pdfWindow = window.open();
                    pdfWindow.location.href = fileURL;
                } else if (response.headers["content-type"] === "application/pdf") {
                    const file = new Blob([response.data], { type: "application/pdf" });
                    const fileURL = URL.createObjectURL(file);
                    //Open the URL on new Window
                    const pdfWindow = window.open();
                    pdfWindow.location.href = fileURL;
                } else if (response.headers["content-type"] === "image/jpeg") {
                    const file = new Blob([response.data], { type: "image/jpeg" });
                    const fileURL = URL.createObjectURL(file);
                    //Open the URL on new Window
                    const pdfWindow = window.open();
                    pdfWindow.location.href = fileURL;
                } else if (response.headers["content-type"] === "image/jpg") {
                    const file = new Blob([response.data], { type: "image/jpg" });
                    const fileURL = URL.createObjectURL(file);
                    //Open the URL on new Window
                    const pdfWindow = window.open();
                    pdfWindow.location.href = fileURL;
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };
    const onUploadFileHandler = (refOperation) => {
        if (document.facture) {
               FileService.generateBonReception(
            getCurrentUserId(),
            document.facture.ref,
            refOperation
          ).then((response) => {
            if (response.data["success"]) {
              setPathFile(response.data["success"]);
              onShowFileInOtherWindowHandler(
                response.data["success"]
              );
            }
          });
        } else if (document.bdc) {
            FileService.generateBonReception(
                getCurrentUserId(),
                document.bdc.ref,
                refOperation
              ).then((response) => {
                if (response.data["success"]) {
                  setPathFile(response.data["success"]);
                  onShowFileInOtherWindowHandler(
                    response.data["success"]
                  );
                }
              });
        }  else if (document.bonDeCommandeSale) {
            FileService.generateBonReceptionSell(
                getCurrentUserId(),
                document.bonDeCommandeSale.ref,
                refOperation
              ).then((response) => {
                if (response.data["success"]) {
                  setPathFile(response.data["success"]);
                  onShowFileInOtherWindowHandler(
                     response.data["success"]
                  );
                }
              });
        } 
      
       
    };
    function buttonFormatter(cell, row) {
        if (row.path !== null) {
            return (
                <span>
                    <button
                        // style={{ width: 40 }}
                        class="btn bg-gray btn-sm "
                        onClick={() =>
                            onShowFileInOtherWindowHandler(
                                row.path
                            )
                        }
                    >
                        <i class="fas fa-eye"></i>
                    </button>
                </span>
            );
        } else {
            return (
                <span>
                    <button
                        // style={{ width: 40 }}
                        class="btn bg-gray btn-sm "
                        onClick={() => onUploadFileHandler(row.uniqueId)}
                    >
                        <i class="fas fa-plus"></i>
                    </button>
                </span>
            );
        }
    }

    const handleInfoClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenInfoAlert(false);
    };


    const pageButtonRenderer = ({
        page,
        active,
        disable,
        title,
        onPageChange,
    }) => {
        const handleClick = (e) => {
            e.preventDefault();
            onPageChange(page);
        };
        const activeStyle = {};
        if (active) {
            activeStyle.backgroundColor = "black";
            activeStyle.color = "white";
        } else {
            activeStyle.backgroundColor = "white";
            activeStyle.color = "black";
        }
        if (typeof page === "string") {
            activeStyle.backgroundColor = "white";
            activeStyle.color = "black";
        }
        return (
            <li className="page-item">
                <button
                    className="btn btn-dark"
                    onClick={handleClick}
                    style={activeStyle}
                >
                    {page}
                </button>
            </li>
        );
    };
    const options = {
        pageButtonRenderer,
    };

    return (
        <div className="card">
            <div className="card-header">
                <h3 className="card-title">Les documents</h3>
                <br/>
                {refFormatterDocument(documentName)} -{titleFormatterDoument(documentName)}
               {testProduction(documentName)}
            </div>
            <div className="card-body">
                <ToolkitProvider
                    keyField="uniqueId"
                    data={transaction}
                    columns={columns}
                    exportCSV
                    search
                >
                    {(props) => (
                        <div>
                            <div className="row ml-0">
                                <div>
                                    <SearchBar
                                        {...props.searchProps}
                                        className="custome-search-field"
                                        style={{ color: "black" }}
                                        placeholder="Chercher"
                                    ></SearchBar>
                                </div>

                            </div>
                            <div className="row">
                                <BootstrapTable
                                    {...props.baseProps}
                                    pagination={paginationFactory(options)}
                                    striped
                                    hover
                                    condensed
                                />
                            </div>
                        </div>
                    )}
                </ToolkitProvider>
            </div>

            {openInfoAlert && (
                <Snackbar
                    open={openInfoAlert}
                    autoHideDuration={2000}
                    onClose={handleInfoClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                >
                    <Alert variant="filled" onClose={handleInfoClose} severity="info">
                        {infoAlertText}
                    </Alert>
                </Snackbar>
            )}
        </div>
    );
}

export default DataTableBonDeSortieSell;
